import { createRoot } from 'react-dom/client';
import { RelayEnvironmentProvider } from 'react-relay';
import { AuthProvider } from '@/contexts/AuthContext';
import { AppRoutes } from '@/routes';
import { relayEnvironment } from '@/relay/environment';
import '@/styles/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('No #root element found');

createRoot(root).render(
  <RelayEnvironmentProvider environment={relayEnvironment}>
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  </RelayEnvironmentProvider>
);
